import { render, staticRenderFns } from "./HorseAjout.vue?vue&type=template&id=08e1d146&"
import script from "./HorseAjout.vue?vue&type=script&lang=js&"
export * from "./HorseAjout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports